import { z } from 'zod';

import { IntegrationType, integrationUrl } from './integration';
import { makeEndpoint } from '../common';

const integrationPrefix = (brandId: string) => integrationUrl({ brandId, integrationType: IntegrationType.ALICE });

export const SendBookingEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId }: { brandId: string }) => `${integrationPrefix(brandId)}/send-booking`,
  requestSchema: z.object({
    reservationId: z.string(),
    bookingId: z.string().uuid(),
  }),
  responseSchema: z.void(),
});

export const AliceCredentialSchema = z.object({
  hotelId: z.string(),
});

export const getAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }: { brandId: string }) => `${integrationPrefix(brandId)}/credential`,
  method: 'GET',
  responseSchema: AliceCredentialSchema,
  requestSchema: z.void(),
});

export const postAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }: { brandId: string }) => `${integrationPrefix(brandId)}/credential`,
  method: 'POST',
  responseSchema: z.void(),
  requestSchema: AliceCredentialSchema,
});
